import { useState, useEffect } from 'react';
import { Key } from 'lucide-react';

export default function CursorToggle() {
  const [keyMode, setKeyMode] = useState(() => {
    const saved = localStorage.getItem('okiescape-cursor');
    return saved !== 'default';
  });

  useEffect(() => {
    if (keyMode) {
      document.documentElement.classList.remove('default-cursor');
      localStorage.setItem('okiescape-cursor', 'key');
    } else {
      document.documentElement.classList.add('default-cursor');
      localStorage.setItem('okiescape-cursor', 'default');
    }
  }, [keyMode]);

  return (
    <button
      onClick={() => setKeyMode(prev => !prev)}
      data-testid="cursor-toggle"
      className="flex flex-col items-center gap-1 mt-3"
      title={keyMode ? 'Switch to normal cursor' : 'Switch to key cursor'}
    >
      <div className={`w-10 sm:w-14 h-10 sm:h-14 rounded-lg flex items-center justify-center border transition-all duration-200 ${
        keyMode
          ? 'bg-brand/20 border-brand/50 shadow-[0_0_12px_rgba(227,37,16,0.3)]'
          : 'bg-neutral-200 dark:bg-neutral-800 border-neutral-300 dark:border-neutral-600'
      }`}>
        <Key size={20} className={`transition-colors ${keyMode ? 'text-brand' : 'text-neutral-400'}`} />
      </div>
      <span className="text-[10px] font-heading tracking-wider text-muted-foreground uppercase">
        {keyMode ? 'Key' : 'Normal'}
      </span>
    </button>
  );
}
